<template>
  <loading-wrapper
    :loading="loading"
    :class="{ 'section': loading }"
  >
    <div
      v-if="selectedEmployee"
      class="section no-padding-top no-padding-x"
    >
      <div class="container max-width-mobile">
        <div
          v-if="selectedDepartment.photoUrl"
          class="department-banner"
          :style="{ 'background-image': `url(${selectedDepartment.photoUrl})` }"
        />

        <div :class="['employee-tipping-page--info', { 'employee-tipping-page--info__with-banner': selectedDepartment.photoUrl }]">
          <div
            v-if="selectedEmployee.photoUrl"
            class="employee-tipping-page--avatar"
            :style="{ 'background-image': `url(${selectedEmployee.photoUrl})` }"
          />
          <h2 class="title title--2 no-spacing">{{ selectedEmployee.firstName }} {{ selectedEmployee.lastName }}</h2>
          <p class="dark-gray no-spacing">Department: <b>{{ selectedDepartment.name }}</b></p>
        </div>

        <hr>

        <mobile-tipping-form
          :employee-public-id="selectedEmployee.publicId"
          :store-id="selectedDepartment.storeId"
        />
      </div>
    </div>
  </loading-wrapper>
</template>

<script>
  import mobileTippingForm from './mobile-tipping-form.vue';
  import { mapGetters } from 'vuex';


  export default {
    name: 'EmployeeTippingPage',

    components: { mobileTippingForm },

    metaInfo() {
      return {
        title: this.selectedEmployee && `${this.selectedEmployee.firstName} ${this.selectedEmployee.lastName}`
      };
    },

    data: () => ({
      loading: true
    }),

    computed: {
      ...mapGetters('hotels', ['selectedEmployee', 'selectedDepartment'])
    },

    created() {
      this.onCreated();
    },

    methods: {
      async onCreated() {
        await this.$store.dispatch('hotels/fetchEmployee', this.$route.params.employeeId);
        this.loading = false;
      }
    }
  };
</script>
